import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  sections = [
    {
      title: 'Juices',
      slug: 'juices',
      description: 'Experience pure refreshment with juices made from world’s best fruits.',
      bg: '#F0567A',
      nextBg: '#FFC033',
      textColor: '#ffffff',
      reverse: false,
      brands: [
        { slug: 'unikai', logo: 'assets/img/brands/brand7.png' },
        { slug: 'areej', logo: 'assets/img/brands/brand11.png' },
        { slug: 'laser', logo: 'assets/img/brands/brand3.png' },
        { slug: 'tropical-fresh', logo: 'assets/img/brands/brand13.png' }
      ],
      image: 'assets/img/products/juices.png'
    },
    {
      title: 'Dairy',
      slug: 'dairy',
      description: 'Wholesome dairy goodness crafted to nourish your everyday life.',
      bg: '#FFC033',
      nextBg: '#09B384',
      textColor: '#1e1e1e',
      reverse: true,
      brands: [
        { slug: 'unikai', logo: 'assets/img/brands/brand7.png' },
        { slug: 'delite', logo: 'assets/img/brands/brand4.png' },
        { slug: 'sambharam', logo: 'assets/img/brands/brand14.png' }
      ],
      image: 'assets/img/products/dairy.png'
    },
    {
      title: 'Ice Cream',
      slug: 'ice-cream',
      description: 'Whether it’s a scoop, a cone, or a stick - every moment becomes special with Unikai Ice Creams.',
      bg: '#09B384',
      nextBg: '#0A485D',
      textColor: '#ffffff',
      reverse: false,
      brands: [
        { slug: 'unikai', logo: 'assets/img/brands/brand7.png' },
        { slug: 'areej', logo: 'assets/img/brands/brand11.png' },
        { slug: 'silk', logo: 'assets/img/brands/brand8.png' },
        { slug: 'magma', logo: 'assets/img/brands/brand1.png' },
        { slug: 'soft-scoop', logo: 'assets/img/brands/brand5.png' },
        { slug: 'shahi-kulfi', logo: 'assets/img/brands/brand10.png' },
        { slug: 'nutty-cone', logo: 'assets/img/brands/brand9.png' }
      ],
      image: 'assets/img/products/ice-cream.png'
    },
    {
      title: 'Rice',
      slug: 'rice',
      description: 'For decades, Unikai has brought families the finest rice- from fragrant basmati to everyday favourites cherished across many regions.',
      bg: '#0A485D',
      nextBg: '#8FDBF5',
      textColor: '#ffffff',
      reverse: true,
      brands: [
        { slug: 'classic-mumtaz', logo: 'assets/img/brands/brand12.png' },
        { slug: 'areej', logo: 'assets/img/brands/brand11.png' },
        { slug: 'al-gubaira', logo: 'assets/img/brands/brand15.png' },
        { slug: 'al-sadah', logo: 'assets/img/brands/brand16.png' }
      ],
      image: 'assets/img/products/rice.png'
    },
    {
      title: 'Foods',
      slug: 'foods',
      description: 'From ketchup to hot sauce, hazelnut spread to frozen food and oil, your pantry essentials, all covered with our convenient food range.',
      bg: '#8FDBF5',
      nextBg: '#24356D',
      textColor: '#1e1e1e',
      reverse: false,
      brands: [
        { slug: 'unikai', logo: 'assets/img/brands/brand7.png' },
        { slug: 'delite', logo: 'assets/img/brands/brand4.png' },
        { slug: 'u', logo: 'assets/img/brands/brand6.png' }
      ],
      image: 'assets/img/products/foods.png'
    },
    {
      title: 'Download Brochure',
      slug: 'download-brochure',
      description: 'Get detailed insights about our products and services',
      bg: '#24356D',
      textColor: '#ffffff',
      type: 'brochure'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}